<template>
  <div style="overflow-x: none !important">
    <div class="sub-banner">
      <div class="nav-menu">
        <div @click="toSosmed(sosmed.link)"
          v-for="(sosmed, index) in soscialMedia" :key="index" style="cursor: pointer" >
          <component :is="sosmed.img" width="24" height="24" alt="" />
        </div>
      </div>
      <div class="d-flex justify-space-between ma-15 align-center">
        <div style="padding-left: 100px;">
          <h1 class="title-banner">{{ $t('home.heroSection.title') }} <span style="color: #FFDE59;"><u>{{ $t('home.heroSection.yellowTitle') }}</u></span></h1>
          <p class="sub-title-banner" style="max-width: 1000px; width: 100%; font-weight: 300"
          v-html="$t('home.heroSection.subtitle')"></p>

          <div style="display: block;">
            <div class="btn-yellow" style="margin-right: 20px;" @click="scrollToClass('list-of-acceleration')">{{ $t('home.heroSection.viewProgram') }}</div>
            <div class="btn-white" @click="goToCustomerService">{{ $t('home.heroSection.contactUs') }}</div>
          </div>
        </div>
        <div>
          <iframe class="card-image" style="width: 650px; height: 400px"
          src="https://www.youtube.com/embed/7mBp0DYzql4?si=O6Aw9SheRYdJm3a2" title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
      <div class="stats" style="color: white;" >
        <div style="flex-direction: column;" v-for="(i, index) in $t('home.additionalInfo')" :key="index">
          <div class="stat-item">
            <h3 style="margin-right: 10px;">{{i.total}}</h3>
            <span style="width: 50px;" v-html="i.title"></span>

            <div v-if="i.id != 3" style="width: 1px; background-color: white; height: 40px; margin-left: 100px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="div-why-hicol" style="background-color: white;">
        <div style="display: flex; gap: 70px; ">
          <div style="width: 60%;">
            <img src="/img/home/usp.png" alt="main" style="width: 100%; height: 80%; border-top-right-radius: 400px; border-bottom-right-radius: 400px;"/>
          </div>
          <div style="max-width: 40%;">
            <p style="color: #162CA2;font-size: 32px;font-weight: 700;" v-html="$t('home.usp.title')"></p>
            <div class="card-box">
              <div class="card-1" v-for="(item, idx) in $t('home.usp.details')" :key="idx">
                <img :src="item.img" class="img-2" />
                <h3>{{ item.name }}</h3>
                <p>{{ item.description }}</p>
              </div>
            </div>
          </div>
      </div>
    </div>

    <Banner :partners="banners" />

    <div class="list-of-acceleration">
      <div class="container">
        <h1 class="text-center my-1" style="color: #162CA2;" v-html="$t('home.accelerationProgramSection.title')"></h1>
        <div class="nav-container">
          <button v-for="(tab, index) in tabs" :key="index" :class="{ 'active': activeTab === tab }"
            @click="setActiveTab(tab)">
            {{ tab }}
          </button>
        </div>
        <div class="card" style="padding-bottom: 60px">
          <div class="items" v-for="(item, idx) in listClass" :key="idx" @click="directDetail(item.slug_name)"
            :title="item.name">
            <div style="height: 160px">
              <img :src="item.image_url" :alt="`${item.name}`" style="width: 100%; height: 100%; border-radius: 20px 20px 0 0" />
              <div class="label" v-if="item.collaboration_feed">
                <img :src="item.collaboration_feed" alt="" style="width: 80%" />
              </div>
            </div>
            <div class="content">
              <div style="height: 45px;">
                <h2>{{ item.name }}</h2>
              </div>
              <div class="category">
                <div style="background-color: #f1f6ff" v-if="item.level">
                  <p>{{ item.level }}</p>
                </div>
              </div>
              <div class="event-ctn-info my-2" v-if="item.session">
                <NoteIcon :width="25" fill="#575966" />
                <span class="name">{{ item.session }} {{ $t('home.a2') }}</span>
              </div>
              <div class="event-ctn-info my-2" v-if="activeTab != 'Event'">
                <AwardIcon :width="25" fill="#575966" />
                <span class="name">Reguler / Private</span>
              </div>
              <div class="event-ctn-info" v-if="item.days">
                <DateIcon :width="22" fill="#575966" />
                <span class="name">{{ item.days }}</span>
              </div>
              <div class="event-ctn-info" v-if="item.hours">
                <Clock :width="22" fill="#575966" />
                <span class="name">{{ item.hours }}</span>
              </div>
              <div class="event-ctn-info" v-if="item.method">
                <Methode :width="22" fill="#575966" />
                <span class="name">{{ item.method | toMethode }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="div-for-corporate" style="background-color: white;">
      <div class="container">
        <div style="display: flex; gap: 70px; ">
          <div style="max-width: 40%;">
            <p class="margin-0" v-html="$t('home.accelerationPrograms.corporateServiceSection.title')"> </p>
            <h1 class="margin-0" style="line-height: 44px;color: #162CA2;" v-html="$t('home.accelerationPrograms.corporateServiceSection.subtitle')"></h1>
            <p class="mt-4">{{ $t('home.accelerationPrograms.corporateServiceSection.description') }}</p>
            
          </div>
          <div style="max-width: 60%;">
            <div class="card-box">
              <div class="card-1" v-for="(item, idx) in $t('home.descs1')" :key="idx">
                <img :src="item.img" class="img-2" />
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
                <div class="btn-blue" @click="navigateWithRouter(item.url, '')" style="margin: 20px 0 0 0;">
                  <span class="font-poppins">{{ $t('home.learnMore') }}</span>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>

    <div class="logo">
      <div style="text-align: center;"><h2 style="color: #162CA2">{{ $t('home.titleLogoPartner') }}</h2></div>
      <div class="card-container">
        <div class="card">
          <div v-for="(partner, index) in partners" :key="index">
            <div class="logo-card-partner-2">
              <img :src="partner.img_url_web" width="160" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="div-testimonies">
      <div class="container">
        <h1 class="mb-10 text-center" style="line-height: 35px;color: #162CA2;" v-html="$t('home.accelerationPrograms.testimonySection.title')"></h1>
        <div style="display: flex; gap: 30px; ">
          <div class="card-2" v-for="(item, idx) in testimonies" :key="idx">
            <img src="/img/home/quote.png" alt="main" style="width: 24px; height: 24px">
            <p class="text-left mt-2" style="height: 200px; font-size: 14px;">{{ item.feedback }}</p>
            <div class="profile mt-5 d-flex" style="align-items: center">
              <div class="avatar">
                <v-img :src="$utils.loadImage(item.image_url)" alt="" width="60" height="60" class="avatar-image" />
              </div>
              <div class="testi-profile ml-5">
                <div class="name">{{ item.name }}</div>
                <div class="description">
                  {{ item.job }} {{ item.place }}
                </div>
                <v-img v-if="item.linkedin" src="/img/home/linkedin.png" alt="" width="23" height="23"
                  @click="redirectReload(item.linkedin)" class="linkedin-image cursor-pointer" />
              </div>
            </div>
          </div>
        </div>

        <div class="btn-stoke-blue" style="margin: 50px auto 0 auto;" @click="$router.push('/testimony')">
          <span class="font-poppins">{{ $t('home.a1') }}</span>
          <ArrowLong />
        </div>
      </div>
    </div>

    <div class="mt-15" @click="goToCustomerService">
      <img src="/img/home/contact-us.png" alt="main" style="width: 100%; height: 100%;cursor: pointer;">
    </div>

    <div class="faq">
      <div class="content">
        <h1 style="color: #162CA2; text-align: center;" v-html="$t('faqHeroTitle')"></h1>
        <div class="row">
          <v-expansion-panels flat class="faq-card" style="padding: 20px;">
            <v-expansion-panel v-for="(item, index) in questions" :key="index" style="border-radius: 20px; padding: 0; margin-bottom: 10px; border: 1px solid #D3D6E1;">
              <v-expansion-panel-header disable-icon-rotate @click="openFaq(index)">
                <h2 style="margin: 25px 0; font-size: 18px;">{{ item.title }}</h2>
                <template v-slot:actions>
                  <div class="icon" v-if="item.active"><Arrow /></div>
                  <div v-else><Arrow :down="!item.active" /></div>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-html="item.description"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="btn-stoke-blue cursor-pointe mt-10" @click="$router.push('/faq')" style="background-color: white;margin-left: auto;margin-right: auto;">
          <span class="font-poppins">{{ $t('home.a1') }}</span>
          <ArrowLong />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goTo from 'vuetify/lib/services/goto';
import Banner from '../Banner.vue';
import Arrow from '@/assets/icons/Arrow.vue';
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import Instagram from '@/assets/icons/sosmed/Instagram.vue';
import Facebook from '@/assets/icons/sosmed/Facebook.vue';
import Linkedin from '@/assets/icons/sosmed/Linkedin.vue';
import Tiktok from '@/assets/icons/sosmed/Tiktok.vue';
import Youtube from '@/assets/icons/sosmed/Youtube.vue';
import NoteIcon from '@/assets/icons/Note.vue';
import AwardIcon from '@/assets/icons/Award.vue';

export default {
  components: {
    NoteIcon,
    AwardIcon,
    Instagram,
    Facebook,
    Linkedin,
    Tiktok,
    Youtube,
    Banner,
    Arrow,
    ArrowLong,
  },
  data() {
    return {
      dialog: true,
      mobileView: false,
      notifActive: true,
      is_login_show: false,
      partners: [],
      bootcampClass: [],
      prakerjaClass: [],
      recommendationClass: [],
      banners: [],
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic',
      soscialMedia: [
        {
          name: 'instagram',
          img: Instagram,
          link: 'https://instagram.com/hicolleagues',
        },
        {
          name: 'facebook',
          img: Facebook,
          link: 'https://www.facebook.com/hicolleagues/',
        },
        {
          name: 'linkedin',
          img: Linkedin,
          link: 'https://www.linkedin.com/company/hicolleagues?originalSubdomain=id',
        },
        {
          name: 'tiktok',
          img: Tiktok,
          link: 'https://www.tiktok.com/@hicolleagues',
        },
        {
          name: 'youtube',
          img: Youtube,
          link: 'https://www.youtube.com/@HiColleagues',
        },
      ],
      testimonies: [],
      accelerations: [],
      listClass: [],
      questions: [],
      events: [],
      tabs: ['Bootcamp', 'Certification', 'Event'],
      activeTab: 'Bootcamp',
    };
  },
  computed: {
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
  },
  watch: {
    '$i18n.locale'() {
      this.setActiveTab(this.activeTab);
      this.getFaq();
      this.getTestimoni();
    },
  },
  methods: {
    scrollToClass(className) {
      const element = document.querySelector(`.${className}`);
      if (element) {
        goTo(element.offsetTop, {
          duration: 600,
          easing: 'easeInOutCubic'
        });
      }
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.$gtag.event('click', {
        event_category: 'Tab',
        event_label: `Tab - ${tab}`,
        value: 1,
      });
       if (tab === 'Bootcamp') {
        this.getBootcampClass();
      } else if (tab === 'Certification') {
        this.getAccelerationClass();
      } else {
        this.getDataEvents();
      }
    },
    directDetail(slugName) {
      const item = this.listClass.find(item => item.slug_name === slugName);
      if (item) {
        this.$gtag.event('view_item', {
          event_category: 'E-commerce',
          event_label: item.name,
          value: item.price || 0,
          items: [
            {
              item_id: item.slug_name,
              item_name: item.name,
              item_category: this.activeTab,
              price: item.price || 0,
              quantity: 1,
            },
          ],
        });
      }
      if (this.activeTab === 'Bootcamp') {
        this.$router.push(`/class/bootcamp/${slugName}`);
      } else if (this.activeTab === 'Certification') {
        this.$router.push(`/certification/detail/${slugName}`);
      } else {
        this.$router.push(`/event/detail/${slugName}`);
      }
    },
    directOther() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `${this.activeTab} See More Button`,
        value: 1,
      });
      if (this.activeTab === 'Bootcamp') {
        this.$router.push('/class/bootcamp');
      } else if (this.activeTab === 'Certification') {
        this.$router.push('/certification');
      } else {
        this.$router.push('/event');
      }
    },
    redirectReload(e) {
      if (e.slice(0, 5) === 'https') {
        this.$gtag.event('click', {
          event_category: 'Social Media',
          event_label: `LinkedIn Testimony - ${e}`,
          value: 1,
        });
        window.open(e, '_blank');
      } else {
        this.$router.push({ path: e }).then(() => {
          this.$router.go();
        });
      }
    },
    toMethode(value) {
      if (!value) return;
      if (value.toLowerCase() === 'online') {
        return 'Daring';
      } else if (value.toLowerCase() === 'offline') {
        return 'Luring';
      } else {
        return value;
      }
    },
    toDiscount(item) {
      const total_price = item.price - item.discount;
      if (total_price <= 0) {
        return 'FREE';
      } else {
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        return formatter.format(total_price);
      }
    },
    openFaq(idx) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `FAQ - ${this.questions[idx].title}`,
        value: 1,
      });
      const valDef = this.questions[idx].active;
      this.questions.forEach(e => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=HOME&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    toSosmed(link) {
      this.$gtag.event('click', {
        event_category: 'Social Media',
        event_label: `Social Media - ${link}`,
        value: 1,
      });
      window.open(link, '_blank');
    },
    goToCustomerService() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Customer Service WhatsApp',
        value: 1,
      });
      window.location.href = 'https://api.whatsapp.com/send/?phone=6285110563798&text=Hi Kak HiColleagues, saya mau bertanya';
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(`/v1/testimony?category=HOME&is_active=true&page=1&per_page=3`);
        this.testimonies = resp.data.data.testimonies;
      } catch (err) {
        console.log(err);
      }
    },
    async getBanners() {
      await this.$http
        .get('/v1/banner?category=GENERAL&is_active=true')
        .then((response) => {
          this.banners = response.data.data.banners;
        })
        .catch((err) => console.error(err.response));
    },
    async getDataEvents() {
      try {
        const resp = await this.$http.get(`/v1/event?is_active=true`);
        this.listClass = resp.data.data.events.map((item) => ({
          ...item,
          image_url: item.img_urls.desktop.thumbnail,
          session: item.total_session,
          days: '',
          hours: `${item.session_schedules[0].start_time} - ${item.session_schedules[0].end_time} WIB`,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    async getBootcampClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/5?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getAccelerationClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/6?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get('/v1/logo?category=CORPORATE');
        this.partners = resp.data.data.logos;
        this.partners = [...this.partners, ...this.partners, ...this.partners, ...this.partners];
      } catch (err) {
        console.log(err);
      }
    },
    goToHomePage() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Home Page',
        value: 1,
      });
      this.$router.push({ path: '/' }).then(() => {
        this.$router.go();
      });
    },
    goToLoginPage() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Login Page',
        value: 1,
      });
      this.$router.push({ path: '/login' }).then(() => {
        this.$router.go();
      });
    },
    goToRouter(link) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Router - ${link}`,
        value: 1,
      });
      this.$router.push({ path: link }).then(() => {
        this.$router.go();
      });
    },
    goToEvent() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Event Button',
        value: 1,
      });
      this.$router.push({ path: '/event' }).then(() => {
        this.$router.go();
      });
    },
    goToCertification() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Certification Button',
        value: 1,
      });
      this.$router.push({ path: '/certification' }).then(() => {
        this.$router.go();
      });
    },
    goToCorporateTraining() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Pelatihan Karyawan Button',
        value: 1,
      });
      this.$router.push({ path: '/corporate/training' }).then(() => {
        this.$router.go();
      });
    },
    // goToBootcamp() {
    //   this.$gtag.event('click', {
    //     event_category: 'Button',
    //     event_label: 'Bootcamp Button',
    //     value: 1,
    //   });
    //   this.$router.push({ path: '/class/bootcamp' }).then(() => {
    //     this.$router.go();
    //   });
    // },
    minimize(text) {
      return text.length > 290 ? text.slice(0, 290) + '...' : text;
    },
    navigateWithRouter(route, slug){
      if(route != ""){
        this.$router.push(route + slug);
      }
    },
    async toCheckout(data) {
      this.isLoading = true;
      try {
        const response = await this.$http.get(`/v1/class-detail/${data.slug_name}`);
        const classDetail = response.data.data.class_detail;

        this.$gtag.event('add_to_cart', {
          event_category: 'E-commerce',
          event_label: classDetail.name,
          value: classDetail.price || 0,
          items: [
            {
              item_id: classDetail.class_id,
              item_name: classDetail.name,
              item_category: classDetail.category_id,
              price: classDetail.price || 0,
              quantity: 1,
            },
          ],
        });

        const reqCheckout = JSON.stringify({
          class_id: classDetail.class_id,
          class_name: classDetail.name,
          price: classDetail.price,
          level: classDetail.level,
          session: classDetail.session_total,
          hour: classDetail.hours,
          image_url: classDetail.small_image_url,
          class_type: 'PRAKERJA_CLASS',
          days: classDetail.days,
          methode: classDetail.method,
          category_id: classDetail.category_id,
        });

        localStorage.clear();
        localStorage.setItem('checkout', reqCheckout);
        this.isLoading = false;
        window.location.href = '/checkout';
      } catch (err) {
        this.isLoading = false;
        console.error(err.response);
      }
    },
  },
  mounted() {
    this.getBanners();
    this.getBootcampClass();
    this.getClientLogo();
    this.getFaq();
    this.getTestimoni();
  },
};
</script>

<style src="./home.css" scoped></style>